var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen"},[_c('navbar-menu',{staticClass:"mb-20"}),_c('terms-and-conditions-header',{staticClass:"w-full"}),_c('terms-and-conditions-content',{staticClass:"mb-12 pb-20 w-full"}),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }